
import { MdsItem, DwgData, ProcessedMds, ValidationResult, Status, Millsheet } from '../types';

export const processMdsData = (dwg: DwgData, rawItems: any[]): { data: Omit<ProcessedMds, 'uploadedAt'> | null; validation: ValidationResult } => {
  const errors: string[] = [];
  
  if (!rawItems || rawItems.length === 0) {
    return { data: null, validation: { isValid: false, errors: ["Data item kosong."] } };
  }

  // 1. Pemrosesan Linear (Sangat stabil, tidak ada data hilang)
  const items: MdsItem[] = rawItems.map((item, index) => {
    const qty_r = parseFloat(item.qty_r) || 0;
    const qty_l = parseFloat(item.qty_l) || 0;
    const qty_total = (qty_r + qty_l) > 0 ? (qty_r + qty_l) : (parseFloat(item.qty_total) || 1);
    const berat_level = parseFloat(item.berat_level) || 0;
    
    return {
      ...item,
      no: item.no || index + 1,
      level: parseInt(item.level) || 0,
      qty_r,
      qty_l,
      qty_total,
      status: item.status || Status.NEW,
      millsheet: item.millsheet || Millsheet.X,
      berat_level,
      berat_total: berat_level * qty_total, // Kalkulasi dasar yang stabil
      parent_part_number: item.parent_part_number || '',
      children: [],
      imdsData: item.imdsData || {
        recyclate: item.recyclate || undefined,
        description: item.description || undefined,
        articleName: item.articleName || undefined,
        name: item.name || undefined,
        substanceName: item.substanceName || undefined,
        partItemNo: item.partItemNo || undefined,
        itemMatNo: item.itemMatNo || undefined,
        materialNo: item.materialNo || undefined,
        casNo: item.casNo || undefined,
        imdsIdVersion: item.imdsIdVersion || undefined,
        quantity: item.quantity || undefined,
        weight: item.weight || undefined,
        portion: item.portion || undefined,
        portionRange: item.portionRange || undefined,
        classification: item.classification || undefined,
        gadslSvhc: item.gadslSvhc || undefined,
        partsMarking: item.partsMarking || undefined,
        sourceOfMaterial: item.sourceOfMaterial || undefined,
        applicationId: item.applicationId || undefined
      }
    };
  });

  // 2. Build Tree Visual (Hanya untuk tampilan, tidak merusak struktur utama)
  const tree: MdsItem[] = [];
  const lastFoundAtLevel: Record<number, MdsItem> = {};

  items.forEach(item => {
    if (item.level === 0) {
      tree.push(item);
    } else {
      const parent = lastFoundAtLevel[item.level - 1];
      if (parent) {
        parent.children = parent.children || [];
        parent.children.push(item);
        item.parent_part_number = parent.part_number_customer;
      } else {
        // Fallback ke root jika parent tidak urut (mencegah data hilang)
        tree.push(item);
      }
    }
    lastFoundAtLevel[item.level] = item;
  });

  const maxLevelFound = items.length > 0 ? Math.max(...items.map(i => i.level)) : 0;

  return {
    data: {
      dwg,
      items,
      tree,
      summary: {
        totalItems: items.length,
        maxLevel: maxLevelFound,
        totalWeight: items.filter(i => i.level === 0).reduce((acc, i) => acc + i.berat_total, 0)
      }
    },
    validation: { 
      isValid: !!dwg.dwg_number, 
      errors 
    }
  };
};
